
import { Modal } from 'antd';
import { InWai, WinAPprize, Content11, Content12 } from '../../type';
import './style.less';
const PublicityModal = ({
    handleCancel,
    isModalOpen,
    identification,
    inWai,
    winAPprize
}: {
    handleCancel: () => void;
    isModalOpen: boolean;
    identification: string;
    inWai: InWai
    winAPprize: WinAPprize
}) => {


    return (


        <Modal
            title={identification}
            visible={isModalOpen}
            onCancel={handleCancel}
            className='publicity-modal'
            width={602}
            centered={true}
            okText='知道了'
            closeIcon={<div className='publicity-modal-close-icon'></div>}
            footer={null}
            keyboard
            maskClosable={false}
            getContainer={() => document.querySelector('.p-p-foundathon-publicity-wrapper') as HTMLDivElement ?? document.body}
        >
            <div className='publicity-modal-wrapper'>
                <div className='publicity-modal-wrapper-modules'>
                    {
                        identification === inWai.title
                            ? inWai?.content.map((v1: Content11, index: number) => {
                                return (
                                    <div className='publicity-modal-wrapper-modules-title' key={index}>
                                        { v1.title ?? '' }
                                    </div>
                                )
                            })

                            : winAPprize?.content.map((v1: Content12, index: number) => {
                                return (
                                    <div className='publicity-modal-wrapper-modules-winAPprize' key={index}>
                                        <div className='publicity-modal-wrapper-modules-winAPprize-title'>
                                            { v1.title ?? '' }
                                        </div>
                                        <div className='publicity-modal-wrapper-modules-winAPprize-teams'>
                                            {
                                                v1.teamList.map((el: Content11, i: number) => {
                                                    return (
                                                        <div className='publicity-modal-wrapper-modules-winAPprize-teams-team' key={i}>
                                                            { el.title ?? '' }
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                )
                            })
                            
                    }
                </div>
                <div className='publicity-modal-wrapper-btn' onClick={() => handleCancel()}>
                    <div className='p-p-foundathon-banner-btn-list-btn'>
                        <div className='p-p-foundathon-banner-btn-list-btn-name'>知道了</div>
                    </div>
                </div>
            </div>
        </Modal>

    );
};

export default PublicityModal;